const { InspectorControls } = wp.blockEditor;
const { PanelBody, TextControl, ToggleControl, SelectControl } = wp.components;
import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const {} = attributes;

  return (
    <InspectorControls>
      <PanelBody title={'Atributos do Grid'} initialOpen={true}>
        <p>Imagem Coluna 1</p>
        <br />
        <ImageControl
          image="image"
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <br />
        <p>Imagem Coluna 2</p>
        <br />
        <ImageControl
          image="image2"
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
